import React from "react";

import { useThemeToggle } from "../../../context/ThemeContext";
import { IconeLua, IconeSol } from "./icones";

/**
 * Sol/lua do topo. Usa o tema do app (ThemeContext), não um estado próprio:
 * a escolha feita aqui vale para o ERP inteiro depois do login.
 */
export default function BotaoTema({ escuro }) {
  const tema = useThemeToggle();
  const rotulo = escuro ? "Ativar tema claro" : "Ativar tema escuro";
  return (
    <button className="theme-b" type="button" aria-label={rotulo} title={rotulo} onClick={() => tema?.toggle()}>
      {/* Ícones diferentes = elementos novos, então a animação de giro do
          design (.theme-b svg) repete a cada troca. */}
      {escuro ? <IconeSol /> : <IconeLua />}
    </button>
  );
}
